/* Xcalion customiser (2027 range): shows the design/colour/name panel for the Custom colourway
   and makes sure a Custom racket never reaches the basket without its details.
   Design-only colour rules go in RULES, e.g. { Design: 'Colour' }. None in the 2027 range. */
(function(){
  var NP = window.NP = window.NP || {};
  var RULES = {};

  function Xcz(root){
    this.root = root;
    this.pdp = root.closest('[data-np-pdp]');
    this.customId = +root.dataset.custom;
    this.panel = root.querySelector('[data-np-xcz-panel]');
    this.model = root.dataset.model || 's2';
    this.base = (root.dataset.files || '').split('?')[0].replace(/[^\/]+$/, '');
    this.render = this.pdp && this.pdp.querySelector('[data-np-xcz-render]');
    this.rimg = this.render && this.render.querySelector('[data-np-xcz-rimg]');
    this.rname = this.render && this.render.querySelector('[data-np-xcz-rname]');
    this.mini = root.querySelector('[data-np-xcz-mini]');
    this.summary = root.querySelector('[data-np-xcz-summary]');
    this.nameIn = root.querySelector('[data-np-xcz-name]');
    this.err = root.querySelector('[data-np-xcz-err]');
    var self = this;
    root.addEventListener('change', function(){ self.showRender(true); self.paint(); });
    root.addEventListener('click', function(e){
      if (!e.target.closest('[data-np-xcz-view]')) return;
      self.showRender(true);
      var g = self.pdp && self.pdp.querySelector('[data-np-main]');
      if (g) g.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    /* a gallery thumbnail shows that photo; any design change brings the render back */
    if (this.pdp) this.pdp.addEventListener('click', function(e){ if (e.target.closest('[data-np-thumb]')) self.showRender(false); });
    if (this.rimg) this.rimg.addEventListener('load', function(){ self.rimg.classList.remove('ld'); self.fitName(); });
    window.addEventListener('resize', function(){ self.fitName(); });
    if (this.nameIn) this.nameIn.addEventListener('input', function(){
      /* keep it to plain characters Xcalion can print */
      var v = self.nameIn.value.replace(/[^A-Za-z0-9 .,'&\-ÁÉÍÓÚÑÜáéíóúñü]/g, '');
      if (v !== self.nameIn.value) self.nameIn.value = v;
      self.showRender(true);
      self.paint();
    });
    document.addEventListener('np:pdp:variant', function(e){
      if (!self.pdp || !self.pdp.contains(root)) return;
      self.setCustom(e.detail.variant.id === self.customId);
    });
    this.setCustom(this.pdp && this.pdp.classList.contains('is-custom'));
  }
  Xcz.prototype.q = function(s){ return this.root.querySelector(s); };
  Xcz.prototype.qa = function(s){ return [].slice.call(this.root.querySelectorAll(s)); };
  Xcz.prototype.setCustom = function(on){
    if (!this.panel) on = false;
    this.on = on;
    if (this.pdp) this.pdp.classList.toggle('is-custom', on);
    this.root.classList.toggle('on', on);
    if (this.panel) this.panel.hidden = !on;
    this.qa('input[name^="properties["]').forEach(function(i){ i.disabled = !on; });
    if (!on && this.err) this.err.hidden = true;
    this.showRender(on);
    this.paint();
  };
  Xcz.prototype.values = function(){
    var d = this.q('input[name="properties[Design]"]:checked');
    var c = this.q('input[name="properties[Colour]"]:checked');
    return {
      design: d ? d.value : '', art: d ? d.dataset.art : '',
      colour: c ? c.value : '', hex: c ? c.dataset.hex : '',
      name: this.nameIn ? this.nameIn.value.trim().toUpperCase() : ''
    };
  };
  Xcz.prototype.paint = function(){
    var self = this, v = this.values();
    /* design rules */
    var only = RULES[v.design] || null;
    this.qa('input[name="properties[Colour]"]').forEach(function(i){
      i.disabled = !self.on || (only !== null && i.value !== only);
    });
    if (only && v.colour !== only){
      var f = this.q('input[name="properties[Colour]"][value="' + only + '"]');
      if (f){ f.checked = true; v = this.values(); }
    }
    var rule = this.q('[data-np-xcz-rule]');
    if (rule){ rule.hidden = !only; if (only) rule.textContent = 'The ' + v.design + ' design comes in ' + only + ' only.'; }
    /* labels */
    var ld = this.q('[data-np-xcz-lbl="design"]'), lc = this.q('[data-np-xcz-lbl="colour"]'), cnt = this.q('[data-np-xcz-count]');
    if (ld) ld.textContent = v.design;
    if (lc) lc.textContent = v.colour;
    if (cnt) cnt.textContent = this.nameIn ? this.nameIn.value.length : 0;
    /* live render: pre-rendered racket for model + design + colour, name drawn on top */
    var url = this.url(v);
    if (this.rimg && url && this.rimg.dataset.src !== url){
      this.rimg.dataset.src = url; this.rimg.classList.add('ld');
      this.rimg.src = url + '?width=1200';
      this.rimg.srcset = url + '?width=600 600w, ' + url + '?width=900 900w, ' + url + '?width=1200 1200w';
      this.rimg.sizes = '(max-width: 1000px) 100vw, 50vw';
    }
    if (this.mini && url && this.mini.dataset.src !== url){ this.mini.dataset.src = url; this.mini.src = url + '?width=240'; }
    if (this.summary) this.summary.textContent = [v.design, v.colour, v.name].filter(Boolean).join(' · ');
    if (this.rname){ this.rname.textContent = v.name; this.fitName(); }
    this.preload(v);
  };
  Xcz.prototype.url = function(v){
    if (!this.base || !v.design || !v.colour) return '';
    var slug = function(x){ return x.toLowerCase().replace(/\s+/g, '-'); };
    return this.base + 'xc-' + this.model + '-' + slug(v.design) + '-' + slug(v.colour) + '.webp';
  };
  /* warm the cache for the other colours of this design, so swatches swap instantly */
  Xcz.prototype.preload = function(v){
    if (this.pre === v.design || !this.on) return; this.pre = v.design; var self = this;
    this.qa('input[name="properties[Colour]"]').forEach(function(i){
      if (i.disabled) return;
      var u = self.url({ design: v.design, colour: i.value }); if (u) (new Image()).src = u + '?width=900';
    });
  };
  Xcz.prototype.showRender = function(on){
    if (this.render) this.render.hidden = !(on && this.on);
  };
  /* name position/size per model, as fractions of the square render (measured from Xcalion's 2027 configurator) */
  var NAMEPOS = {"s2": {"x": 0.5015, "y": 0.0742, "h": 0.0107, "w": 0.2181}, "m2": {"x": 0.5015, "y": 0.0742, "h": 0.0107, "w": 0.2181}, "x1": {"x": 0.4997, "y": 0.073, "h": 0.0107, "w": 0.2174}, "h2": {"x": 0.4997, "y": 0.073, "h": 0.0107, "w": 0.2174}};
  Xcz.prototype.fitName = function(){
    var n = this.rname; if (!n) return;
    var st = n.parentNode, w = st.clientWidth, pos = NAMEPOS[this.model] || NAMEPOS.s2;
    if (!w || !pos) return;
    n.style.left = (pos.x * 100) + '%'; n.style.top = (pos.y * 100) + '%';
    var fs = Math.max(8, pos.h * w * 1.38); n.style.fontSize = fs + 'px';
    var max = pos.w * w; if (n.scrollWidth > max) n.style.fontSize = (fs * max / n.scrollWidth) + 'px';
  };
  /* Every add to basket (main form, kit builders, sticky bar) passes through here. */
  Xcz.prototype.check = function(items){
    var self = this, v = this.values(), ok = true;
    items.forEach(function(it){
      if (+it.id !== self.customId) return;
      if (!v.design || !v.colour){ ok = false; return; }
      var p = it.properties || {};
      p.Design = v.design; p.Colour = v.colour;
      if (v.name) p['Name on racket'] = v.name; else delete p['Name on racket'];
      p._Lead = 'Made to order, ships in 10 to 14 days';
      it.properties = p;
    });
    if (!ok && this.err){
      this.err.hidden = false;
      this.err.textContent = 'Pick a design and a colour for your custom racket.';
      this.root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else if (this.err) this.err.hidden = true;
    return ok;
  };

  function init(){
    [].forEach.call(document.querySelectorAll('[data-np-xcz]'), function(r){
      if (r.npXcz) return;
      r.npXcz = new Xcz(r);
      NP.addHooks = NP.addHooks || [];
      NP.addHooks.push(function(items){ return document.body.contains(r) ? r.npXcz.check(items) : true; });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
